package net.sergeych.kilogin.server

import kotlinx.serialization.Serializable
import net.sergeych.crypto2.SigningSecretKey
import net.sergeych.crypto2.SymmetricKey

/**
 * The base payload class for kilogin dance, it contains basic information
 * needed for an average kilogin system:
 *
 * - login (whatever string, say, email)
 * - login private key (used only to sign in to a service)
 * - storage key (used to safely keep stored data)
 */
@Serializable
data class RestoreAccessPayload(
    val login: String,
    val loginPrivateKey: SigningSecretKey,
    val dataStorageKey: SymmetricKey,
    val packedSecretData: UByteArray?,
) {
}